<template>
  <header class="header uk-light company-header-component">
    <div class="container">
      <nav uk-navbar>
        <!-- left Side Content -->
        <div class="uk-navbar-left company-navbar-left">
          <div v-if="choosedCompany?.name" class="company-name-wrapper">
            <span class="company-name-text">
              {{ $t('general.selected_company') }}: {{ choosedCompany.name }}
            </span>
            <span v-if="choosedCompany.id === parentCompany?.company_id" class="uk-label uk-label-primary">
              {{ $t('general.main_company') }}
            </span>
          </div>
          <!-- menu icon -->
          <span class="mmenu-trigger" uk-toggle="target: #wrapper ; cls: mobile-active">
            <button class="hamburger hamburger--collapse" type="button">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </span>
        </div>
        <!--  Right Side Content   -->
        <div class="uk-navbar-right">
          <div class="header-widget">
            <!-- Anzera Power -->
            <div v-if="$roleCount() > 1" class="header-widget-icon anzera-chatbot-header-icon">
              <AnzeraChatBot/>
            </div>

            <!-- Sub Company Dropdown -->
            <SubCompanyDropdown ref="subCompanyDropdown"
                                :choosed-company="choosedCompany"
                                :parent-company="parentCompany"
                                :sub-companies="subCompany"
                                @select="chooseSubCompany"/>

            <!-- Language  -->
            <a v-if="superAdmin() && superAdminToken" :uk-tooltip="`title: Kullanıcı Sayfasından çıkış yap`"
               class="header-widget-icon"
               style="color:red" @click="leaveFromUser()">
              <i class="uil-eye" style="color:#ffffff !important"></i>
            </a>
            <!-- Language Component -->

            <!-- Notification Dropdown -->
            <NotificationDropdown ref="notificationDropdown" :format-date="fixDateToNow"
                                  :notification-count="notificationCount" :notification-items="notificationItems"/>
            <!-- Message Notification Dropdown -->
            <message-notification-dropdown :format-date-function="fixDateToNow"
                                           :is-chat-disabled="isChatDisabled"
                                           :item-count="itemCount"
                                           :message-items="messageItems"
                                           :show-settings="true"
                                           header-title="Mesajlar"
                                           icon-style="color:#ffffff !important"
                                           @message-click="(item) => closeDropdown('User.messages', 'messageRefs', item)"
                                           @see-all-click="closeDropdown('User.messages', 'messageRefs')"
            />

            <LanguageSelector/>
            <!-- Profile Dropdown -->
            <CompanyProfileDropdown ref="profileDropdown" :is-sub-company-selected="isSubCompanySelected"
                                    :user-info="user_header"
                                    @logout="onLogout"
                                    @go-to-main-company="goToMainCompany"/>
          </div>
        </div>
        <!-- End Right Side Content / End -->
      </nav>
    </div>
    <!-- container  / End -->
  </header>
</template>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";
import { GET_ITEMS } from "@/core/services/store/REST.module";
import company_module, {
  MODULE_NAME as COMPANY_MODULE_NAME,
  ONLINE_USERS,
  GET_SELF as COMPANY_GET_SELF,
  SELF_URL as COMPANY_SELF_URL,
} from "@/core/services/store/company.module";
import notification_module, {
  COUNT as NOTIFICATION_COUNT,
  GET_COUNT as NOTIFICATION_GET_COUNT,
  ITEMS as NOTIFICATION_ITEMS,
  GET_ITEMS as NOTIFICATION_GET_ITEMS,
  MODULE_NAME as NOTIFICATION_MODULE_NAME,
} from "@/core/services/store/notification.module";
import store from "@/core/services";
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import _ from "lodash";
import EventBus from "@/view/components/event-bus";
import axios from "axios";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });
import { parentCompany, subCompany } from "@/core/services/store.js";
import { getSubCompanyId } from "@/core/services/store.js";
import LanguageSelector from "@/view/components/LanguageSelector.vue";
import AnzeraChatBot from "@/view/components/chatbot/AnzeraChatBot.vue";
import MessageNotificationDropdown from "@/view/components/notification/MessageNotificationDropdown.vue";
import NotificationDropdown from "@/view/layouts/shared/components/NotificationDropdown.vue";
import CompanyProfileDropdown from "@/view/layouts/admin/components/CompanyProfileDropdown.vue";
import SubCompanyDropdown from "@/view/layouts/admin/components/SubCompanyDropdown.vue";

export default {
  name: "Header",
  components: {
    LanguageSelector,
    AnzeraChatBot,
    MessageNotificationDropdown,
    NotificationDropdown,
    CompanyProfileDropdown,
    SubCompanyDropdown
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(COMPANY_MODULE_NAME, company_module);
    registerStoreModule(NOTIFICATION_MODULE_NAME, notification_module);
  },
  data() {
    return {
      subCompany: subCompany,
      superAdminToken: null,
      messagesUrl: "api/user-messages",
      messagesCountUrl: "api/user-messages-count",
      messageItems: [],
      itemCount: 0,
    };
  },
  methods: {
    chooseSubCompany(event) {
      getSubCompanyId.value = event.id
      ls.set("choosedCompany", event);
      let newUser = JSON.parse(ls.get("user"))
      newUser.company_id = event.id;
      ls.set("user", JSON.stringify(newUser));
      // this.$router.push('/dashboard');
      window.location.reload();

    },
    goToMainCompany() {
      const mainCompany = (this.subCompany || []).find(
          company => company.id === this.parentCompany?.company_id
      );
      if (mainCompany) {
        this.chooseSubCompany(mainCompany);
      }
    },
    superAdmin() {
      if (this.user_header === null || !("roles" in this.user_header)) {
        return false;
      }
      if (this.user_header.roles.length > 2) {
        return true;
      } else {
        return false;
      }
    },
    leaveFromUser() {
      axios.delete('api/impersonate/leaving', {
        headers: this.apiHeaders
      })
          .then((response) => {
            if (this.superAdminToken) {
              ls.set("token", this.superAdminToken);
              window.localStorage.removeItem('superAdminToken');
              location.reload();
            }
          })
    },
    getNotifCount() {
      this.$store.dispatch(
          NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_COUNT,
          {}
      );
    },
    closeDropdown(route, refName, params = {}) {
      if (refName === "messageRefs") {
        params = _.merge({}, { message: params });
      }
      this.$router.push({ name: route, params: params });
      const ref = this.$refs[refName];
      if (ref) {
        const el = ref.$refs && ref.$refs[refName] ? ref.$refs[refName] : ref.$el || ref;
        UIkit.dropdown(el).hide(0);
      }
    },
    onLogout() {
      this.$store
          .dispatch(LOGOUT)
          .then(() => this.$router.push({ name: "login" }));
    },
    getNotificationItems() {
      this.$store.dispatch(
          NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_ITEMS,
          {
            filters: {
              limit: 10,
            },
          }
      );
    },
    getMessages() {
      // Chat devre dışıysa mesajları almayı atla
      if (this.isChatDisabled) {
        this.messageItems = [];
        return;
      }

      let self = this;
      self.$store
          .dispatch(GET_ITEMS, {
            url: this.messagesUrl,
            filters: {},
            acceptPromise: false,
          })
          .then((response) => {
            let items = response.data;
            items.forEach((item) => {
              let chatUsers = item.group.users;
              item.user = chatUsers.find(
                  (subItem) => subItem.id === item.sender_user_id
              );
            });
            self.messageItems = items;
          });
    },
    getMessagesCount() {
      // Chat devre dışıysa mesaj sayısını almayı atla
      if (this.isChatDisabled) {
        this.itemCount = 0;
        return;
      }

      let self = this;
      self.$store
          .dispatch(GET_ITEMS, {
            url: this.messagesCountUrl,
            filters: {},
            acceptPromise: false,
          })
          .then((response) => {
            self.itemCount = response.data;
          });
    },
    fixDateToNow(value) {
      return moment(value).locale(this.secureLocalStorage("language") === 'en' ?
          this.secureLocalStorage("language") + 'gb' : this.secureLocalStorage("language")).fromNow();
    },
    async getCompanyItem() {
      await this.$store.dispatch(COMPANY_MODULE_NAME + "/" + COMPANY_GET_SELF, {
        url: COMPANY_SELF_URL,
      });
    },
  },
  computed: {
    choosedCompany() {
      if (ls.get('choosedCompany'))
        return ls.get('choosedCompany');
      else
        return null
    },
    parentCompany() {
      if (ls.get('parentCompany'))
        return JSON.parse(ls.get('parentCompany'));
      else
        return 0
    },
    notificationCount() {
      return store.getters[NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_COUNT];
    },
    notificationItems() {
      return store.getters[NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_ITEMS];
    },
    online_users: {
      get() {
        return store.getters[COMPANY_MODULE_NAME + "/" + ONLINE_USERS];
      },
      set(value) {
      },
    },
    loginLogo() {
      return process.env.BASE_URL + "media/images/avatars/avatar-2.jpg";
    },
    user_header: {
      get() {
        return JSON.parse(this.secureLocalStorage("user"));
      },
      set() {
      },
    },

    isChatDisabled() {
      // Company data henüz yüklenmemişse false döndür
      if (!this.company || !this.company.settings) {
        return false;
      }

      const chatSettings = this.company.settings.find(x => x.key === 'chat_is_disabled');

      // chat_is_disabled tanımlanmamışsa false döndür
      if (chatSettings?.value === undefined || chatSettings?.value === null) {
        return false;
      }
      return chatSettings.value === true || chatSettings.value === 1;
    },
    company() {
      return store.getters[COMPANY_MODULE_NAME + "/" + "SELF"];
    },
    isSubCompanySelected() {
      // Alt kurum seçili mi kontrol et
      if (!this.choosedCompany || !this.parentCompany) {
        return false;
      }
      return this.choosedCompany.id !== this.parentCompany.company_id;
    },
  },
  mounted() {
    this.superAdminToken = ls.get("superAdminToken");

    // Önce company bilgilerini al, sonra mesaj işlemlerini yap
    this.getCompanyItem().then(() => {
      // Company bilgileri yüklendikten sonra mesaj işlemlerini yap
      this.getMessages();
      this.getMessagesCount();
    });

    this.getNotificationItems();
    this.getNotifCount();

    EventBus.$on("message_count", () => {
      // Chat devre dışıysa mesaj sayısını güncelleme
      if (!this.isChatDisabled) {
        this.getMessagesCount();
      }
    });
  },
  watch: {
    $route(to, from) {
      // Notification dropdown'ı kapat
      if (this.$refs.notificationDropdown) {
        this.$refs.notificationDropdown.hide();
      }

      // Profile dropdown'ı kapat
      if (this.$refs.profileDropdown) {
        this.$refs.profileDropdown.hide();
      }

      // Chat devre dışı değilse messageRefs'i de kapat
      if (!this.isChatDisabled && this.$refs.messageRefs) {
        const ref = this.$refs.messageRefs;
        const el = ref.$el || ref;
        UIkit.dropdown(el).hide(0);
      }
    },
  },
};
</script>
<style>
.company-header-component + .uk-tooltip,
.company-header-component .uk-tooltip,
.uk-tooltip {
  color: #ffffff;
}

/* alt kategoriler  */
.company-header-component .dropdown-notifications-headline .uk-search {
  margin-bottom: 10px;
}

.company-header-component .dropdown-notifications-headline .uk-search-input {
  background-color: #ffffff !important;
  border: 2px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 10px 40px 10px 12px !important;
  font-size: 14px !important;
  color: #374151 !important;
  transition: all 0.2s ease-in-out !important;
}

.company-header-component .dropdown-notifications-headline .uk-search-input:hover {
  border-color: #9ca3af !important;
}

.company-header-component .dropdown-notifications-headline .uk-search-input:focus {
  border-color: #3e416d !important;
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.1) !important;
  outline: none !important;
  background-color: #ffffff !important;
}

.company-header-component .dropdown-notifications-headline .uk-search-input::placeholder {
  color: #9ca3af !important;
  opacity: 1 !important;
}

.company-header-component .dropdown-notifications-headline h4 {
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.company-header-component .dropdown-notifications .uk-search-input {
  background-color: #ffffff !important;
  border: 2px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 10px 40px 10px 12px !important;
  font-size: 14px !important;
  color: #374151 !important;
  transition: all 0.2s ease-in-out !important;
  box-sizing: border-box !important;
}

.company-header-component .dropdown-notifications .uk-search-input:hover {
  border-color: #9ca3af !important;
}

.company-header-component .dropdown-notifications .uk-search-input:focus {
  border-color: #3e416d !important;
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.1) !important;
  outline: none !important;
  background-color: #ffffff !important;
}

.company-header-component .dropdown-notifications .uk-search-input::placeholder {
  color: #9ca3af !important;
  opacity: 1 !important;
}

.company-header-component .dropdown-notifications .uk-search-icon-flip {
  color: #6b7280 !important;
}

.company-header-component .notification-dropdown-wrapper .notification-icon-trigger i {
  color: #ffffff !important;
}
</style>
<style scoped>
.header {
  background-color: var(--backgroundColor) !important;
}

/* --- Header widget: referans Header.vue ile aynı davranış --- */
.header >>> .header-widget {
  display: flex !important;
  align-items: center;
  background: transparent !important;
  width: auto !important;
  justify-content: flex-end !important;
  gap: 6px;
  position: relative !important;
  top: auto !important;
  transform: none !important;
  padding: 0 !important;
}

.header >>> .header-widget .header-widget-icon {
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header >>> .header-widget .header-widget-icon i {
  font-size: 28px;
}

.header >>> .anzera-chatbot-header-icon .anzera-chatbot-container {
  z-index: 1;
}

/* --- Company navbar-left --- */
.company-navbar-left {
  display: flex;
  align-items: center;
  margin-top: 2rem;
}

.company-name-wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.company-name-text {
  font-weight: 700;
  color: var(--primaryColor, #3e416d);
  font-size: 18px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 400px;
}

/* --- 1099px altı: hamburger görünür --- */
@media (max-width: 1099px) {
  .company-navbar-left {
    margin-top: 0;
    flex-direction: row-reverse;
  }

  .company-name-text {
    font-size: 14px;
    max-width: 200px;
  }

  .company-navbar-left >>> .mmenu-trigger {
    position: relative;
    left: 0;
    top: 0;
    margin: 0;
    margin-right: auto;
    width: 40px;
    height: 40px;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .company-navbar-left >>> .mmenu-trigger .hamburger {
    position: relative;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;
    transform: scale(0.55);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* --- Mobil (640px) --- */
@media (max-width: 640px) {
  .company-name-wrapper {
    display: none;
  }
}
</style>
